import React from "react"
import Style from "../styles/main.module.css"

export default (props) => (
    <main>
        <div className={Style.main}>
            {props.children}
        </div>
    </main>
)